import UserRolePopover from "../users/components/UserRolePopover";
import { checkPermission } from "../../../permissions/usePermissions";

export const ACTIVE_FORM_KEY = 'activeForm';
export const defaultSection = 'user';
export const PLACEHOLDER = '--';

export const INPUT_TYPES = {

  TEXT: 'text',
  SWITCH: 'switch',
  SELECT: 'select',
  PHONE: 'phone',
  INPUT_GROUP: 'inputGroup',
  RESET_PASSWORD: 'resetPassword',
  IMAGE_UPLOAD: 'imageUpload',
  TRANSFER_RIGHTS: 'transferRights',
}

export const getForm = ({
  countryOptions = [],
  user = {},
  mod,
}) => mod === 'admin' ? ({
  user: {
    position: 0,
    label: 'Application Details',
    inputGroups: [
      {
        title: 'General Info',
        inputs: [
          {
            type: INPUT_TYPES.TEXT,
            label: 'Application ID',
            key: 'applicationId',
            disabled: true,
          },
          {
            type: INPUT_TYPES.TEXT,
            label: 'Application Owner',
            key: 'applicationOwner',
            disabled: true,
          },
          {
            type: INPUT_TYPES.TEXT,
            label: 'Application Name',
            key: 'applicationName',
            disabled: true,
          },
          {
            type: INPUT_TYPES.IMAGE_UPLOAD,
            label: 'App Logotype',
            key: 'appLogotype',
            disabled: true,
          },
        ]
      },
    ]
  },
  security: {
    position: 3,
    label: 'Security',
    inputGroups: [
      {
        isPassword: true,
        title: 'Password',
        subTitle: "Please enter your current password to create a new one.",
        inputs: [
          {
            type: INPUT_TYPES.RESET_PASSWORD,
            label: 'Last Update',
          },
        ],
      },
    ]
  },
}) : ({
  user: {
    position: 0,
    label: 'User',
    inputGroups: [
      {
        title: 'Contact Details',
        subTitle: "This information can't be shared in Datastake.",
        inputs: [
          {
            type: INPUT_TYPES.INPUT_GROUP,
            key: 'name',
            inputs: [
              {
                type: INPUT_TYPES.TEXT,
                label: 'First name',
                placeholder: 'Type first name',
                key: 'firstName',
              },
              {
                type: INPUT_TYPES.TEXT,
                label: 'Last name',
                placeholder: 'Type last name',
                key: 'lastName',
              },
            ]
          },
          {
            type: INPUT_TYPES.SELECT,
            label: 'Gender',
            placeholder: 'Select gender',
            key: 'gender',
            options: [
              {
                label: 'Male',
                value: 'male',
              },
              {
                label: 'Female',
                value: 'female',
              },
            ]
          },
          {
            type: INPUT_TYPES.SELECT,
            label: 'Nationality',
            placeholder: 'Select nationality',
            key: 'nationality',
            options: countryOptions,
          },
          {
            type: INPUT_TYPES.TEXT,
            label: 'Job Title / Position',
            key: 'jobTitle',
            placeholder: 'Type job Title / Position',
          },
          {
            type: INPUT_TYPES.TEXT,
            label: 'Role in the organisation',
            key: 'role',
            disabled: true,
          },
          {
            type: INPUT_TYPES.TEXT,
            label: 'Email address',
            key: 'email',
            disabled: true,
          },
          {
            type: INPUT_TYPES.PHONE,
            label: 'Phone number',
            placeholder: 'Type phone number',
            key: 'phoneNumber',
          },
          {
            type: INPUT_TYPES.PHONE,
            label: 'WhatsApp number',
            placeholder: 'Type whatsApp number',
            key: 'wpNumber',
          },
        ],
      }
    ]
  },
  organisation: {
    label: 'Organisation',
    position: 1,
    inputGroups: [
      {
        title: 'General Info',
        subTitle: "This information helps other users find your organisation in Datastake.",
        inputs: [
          {
            type: INPUT_TYPES.TEXT,
            label: 'Datastake ID',
            key: 'companyId',
            disabled: true,
          },
          {
            type: INPUT_TYPES.TEXT,
            label: 'Administrator email',
            key: 'companyEmail',
            disabled: true,
          },
          {
            type: INPUT_TYPES.SELECT,
            label: 'Country',
            key: 'companyCountry',
            options: countryOptions,
            disabled: true,
          },
          {
            type: INPUT_TYPES.TEXT,
            label: 'Organisation name',
            key: 'companyName',
            disabled: true,
          },
          {
            type: INPUT_TYPES.IMAGE_UPLOAD,
            label: 'Organisation logo',
            key: 'companyLogo',
            disabled: !checkPermission({ permission: 'settings.canEditOrganisation', permissions: user?.role?.permissions }),
          },
        ]
      }
    ]
  },
  notifications: {
    label: 'Notifications',
    position: 2,
    inputGroups: [
      {
        title: 'Email Notifications',
        subTitle: "Notification settings can only be changed by the account administrator.",
        inputs: [
          {
            type: INPUT_TYPES.SWITCH,
            label: 'System',
            subLabel: 'These are essential notifications for users to access and operate the application.',
            key: 'systemNotifiications',
            disabled: true,
            defaultChecked: true,
          },
          {
            type: INPUT_TYPES.SWITCH,
            label: 'Activity',
            subLabel: 'These relate to updates on information compiled by users across the organisation.',
            key: 'activityNotifiications',
            disabled: !checkPermission({ permission: 'settings.canEditNotifications', permissions: user?.role?.permissions }),
          },
          {
            type: INPUT_TYPES.SWITCH,
            label: 'Wallet',
            subLabel: 'These relate to information acquired from, or shared with other organisations.',
            key: 'walletNotifiications',
            disabled: !checkPermission({ permission: 'settings.canEditNotifications', permissions: user?.role?.permissions }),
          },
        ]
      },
      {
        title: 'Email Format',
        subTitle: "Try adjusting the format if emails sent to your organisation are not displayed properly.",
        inputs: [
          {
            type: INPUT_TYPES.SWITCH,
            label: 'Text only',
            subLabel: 'Recommended only if html content is blocked by your email client.',
            key: 'textOnlyEmail',
            disabled: !checkPermission({ permission: 'settings.canEditNotifications', permissions: user?.role?.permissions }),
          },
        ],
      },
    ]
  },
  security: {
    position: 3,
    label: 'Security',
    inputGroups: [
      {
        isPassword: true,
        title: 'Password',
        subTitle: "Please enter your current password to create a new one.",
        inputs: [
          {
            type: INPUT_TYPES.RESET_PASSWORD,
            label: 'Last Update',
          },
        ],
      },
      {
        title: 'Administrator ',
        subTitle: "Manage your organisation's account.",
        isTransferRights: true,
        tooltip: (t) => (
          <UserRolePopover t={t} />
        ),
        inputs: [
          {
            type: INPUT_TYPES.TRANSFER_RIGHTS,
            label: 'Administrator'
          },
        ],
      },
    ].filter((v) => {
      if (!checkPermission({ permission: 'settings.canTransferRights', permissions: user?.role?.permissions })
        && !checkPermission({ permission: 'settings.canResetPassword', permissions: user?.role?.permissions })) {
        return !v.isPassword && !v.isTransferRights;
      }
      if (!checkPermission({ permission: 'settings.canResetPassword', permissions: user?.role?.permissions })) {
        return !v.isPassword;
      }

      if (!checkPermission({ permission: 'settings.canTransferRights', permissions: user?.role?.permissions })) {
        return !v.isTransferRights;
      }

      return true;
    }),
  },
});

const form = getForm({ countryOptions: [] });

export const getDefaultActiveForm = (query) => {
  if (query && query.get(ACTIVE_FORM_KEY)) {
    const v = query.get(ACTIVE_FORM_KEY);
    return Object.keys(form).includes(v) ? v : defaultSection;
  }

  return defaultSection;
}
